<template>
	<form @submit.prevent="submit" class="add-partner-form">
		<div class="add-partner-form__fields">
			<div class="add-partner-form__group">
				<label class="add-partner-form__label" for="name">Imię i nazwisko</label>
				<input
					v-model="form.name"
					required
					class="add-partner-form__input"
					type="text"
					pattern=".{2,}"
					name="name"
					id="name"
				/>
			</div>
			<div class="add-partner-form__group">
				<label class="add-partner-form__label" for="secretCode">Kod partnera (6 cyfr)</label>
				<input
					v-model="form.secretCode"
					required
					class="add-partner-form__input"
					type="text"
					pattern="[0-9]{6}"
					name="secretCode"
					id="secretCode"
				/>
			</div>
			<button
				:disabled="status === 'pending'"
				type="submit"
				class="button add-partner-form__button"
			>
				Dodaj partnera
			</button>
		</div>
		<div v-if="status === 'error'" class="add-partner-form__error">{{ error }}</div>
	</form>
</template>

<script>
import * as R from 'ramda';
import AppDataMixin from '@/mixins/app-data';
import {api} from '@/core/services/api';

export default {
	name: 'PartnerDashboard',
	mixins: [AppDataMixin],
	props: {
		refreshPartnerList: {
			type: Function,
			required: true,
		},
	},
	data() {
		return {
			form: {
				name: null,
				secretCode: null,
			},
			status: 'idle',
			error: null,
		};
	},
	methods: {
		async submit(event) {
			this.status = 'pending';

			try {
				await api.post('/addPartner', {
					secretCode: this.form.secretCode,
					name: this.form.name,
				});
				this.form.name = null;
				this.form.secretCode = null;
				this.status = 'success';
				event.target.reset();
				this.refreshPartnerList();
			} catch (error) {
				console.error(error);
				this.error =
					error.response.data.message || 'Wystąpił niespodziewany błąd, spróbuj jeszcze raz.';
				this.status = 'error';
			}
		},
	},
};
</script>
